import script from "./main-navigation.vue?vue&type=script&lang=ts"
export * from "./main-navigation.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__